import React from 'react';

function ProfileIcon({ className = '', fill = '#212121' }) {
	return (
		<svg
			className={className}
			width='48'
			height='48'
			viewBox='0 0 48 48'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<g clipPath='url(#clip0_1357_45454)'>
				<path
					d='M24 11.8C26.32 11.8 28.2 13.68 28.2 16C28.2 18.32 26.32 20.2 24 20.2C21.68 20.2 19.8 18.32 19.8 16C19.8 13.68 21.68 11.8 24 11.8ZM24 29.8C29.94 29.8 36.2 32.72 36.2 34V36.2H11.8V34C11.8 32.72 18.06 29.8 24 29.8ZM24 8C19.58 8 16 11.58 16 16C16 20.42 19.58 24 24 24C28.42 24 32 20.42 32 16C32 11.58 28.42 8 24 8ZM24 26C18.66 26 8 28.68 8 34V40H40V34C40 28.68 29.34 26 24 26Z'
					fill={fill}
				/>
			</g>
			<defs>
				<clipPath id='clip0_1357_45454'>
					<rect width='48' height='48' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
}

export default ProfileIcon;
